import { Card, Button, InlineStack, OptionList, Popover, Tag, Text, Tooltip, BlockStack } from '@shopify/polaris'
import { doc, setDoc } from 'firebase/firestore'
import { useState } from 'react'
import { usePartnerUp } from '../providers/PartnerUpStoreProvider'

export default function BucketButton({ creator, changeBucketIndex, handleCreateBucket, setChangeBucketIndex, form = null, callback = null, horizontal = false }) {
  const { db, auth, setToast, buckets } = usePartnerUp()
  const [localBuckets, setLocalBuckets] = useState(creator?.buckets || [])

  async function saveBuckets(newBuckets) {
    if (callback) {
      callback(newBuckets)
    } else {
      try {
        /*
        await authFetch(`/api/leads/${creator.id}/buckets`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            buckets: newBuckets
          })
        })
        */
        console.log('uid', auth.currentUser.uid, 'creator', creator.id, 'buckets', newBuckets)
        const docRef = doc(db, 'usersV2', auth.currentUser.uid, 'creators', creator.id)
        await setDoc(docRef, {
          buckets: newBuckets
        }, { merge: true })
        setToast({ content: 'Saved Bucket' })
      } catch (e) {
        setToast({ content: 'Error saving buckets.', isError: true })
        console.error(e)
        setLocalBuckets(creator?.buckets || [])
        console.error(e)
      }
    }
  }

  const renderBuckets = localBuckets?.filter(b => buckets.find(bucket => bucket.id === b))
    .map(bucket => {
      const b = buckets.find(b => b.id === bucket)
      return (
        <Tag padding="1">
          <div
            onClick={(e) => {
              e.stopPropagation()
              setChangeBucketIndex(changeBucketIndex === (creator?.id || form?.id) ? null : (creator?.id || form?.id))
            }}
            size="micro" plain>{b.emoji} {b.name}</div>
        </Tag>
      )
    })

  const Stack = (horizontal) ? InlineStack : BlockStack
  return (
    <InlineStack gap="100" align="start">
      <Popover active={changeBucketIndex && changeBucketIndex === (creator?.id || form?.id)} onClose={() => setChangeBucketIndex(null)} activator={
        renderBuckets?.length ? (
          <Stack gap="100" inlineAlign="start">
            {renderBuckets}
          </Stack>
        ) : (
          <Button size="micro" variant="monochromePlain" disclosure onClick={(e) => {
            e.stopPropagation()
            setChangeBucketIndex(changeBucketIndex === (creator?.id || form?.id) ? null : (creator?.id || form?.id))
          }}>Add</Button>
        )
      }>
        <OptionList
          onChange={v => {
            if (v[0] === 'no-buckets') {
              handleCreateBucket()
              return
            }
            let newBuckets;
            if (localBuckets?.includes(v[0])) {
              newBuckets = localBuckets.filter(b => b !== v[0])
              setLocalBuckets(newBuckets)
            } else {
              newBuckets = [...localBuckets, v[0]]
              setLocalBuckets(newBuckets)
            }
            saveBuckets(newBuckets)
            setChangeBucketIndex(null)
          }}
          options={buckets?.length ? [
            ...buckets.map(bucket => ({
              value: bucket.id, label: (
                <Text>
                  {`${bucket.emoji} ${bucket.name}`}
                </Text>
              ),
              active: localBuckets?.includes(bucket.id)
            })),
            {
              value: 'no-buckets', label: (
                <Text>
                  New Tag
                </Text>
              ),
            }
          ] : [
            {
              value: 'no-buckets', label: (
                <Text>
                  New Tag
                </Text>
              ),
            }
          ]}
          selected={localBuckets}
        />
      </Popover>
    </InlineStack>
  )
}
